/* eslint-disable react/jsx-no-bind */
import React, {useEffect} from 'react';
import {hot} from 'react-hot-loader';
import {BrowserRouter, Route} from 'react-router-dom';
import PageLayout from './components/layouts/PageLayout/PageLayout';

/**
 * Basic provider wrapping. This has been externalized in order to
 * enable hot module replacement features.
 */

/* istanbul ignore next */

const ScrollToTop = ({pathname, search}) => {
    useEffect(() => {
        try {
            window.scroll({
                top: 0,
                left: 0,
            });
        } catch (error) {
            window.scrollTo(0, 0);
        }
    }, [pathname, search]);

    return null;
};

function Root() {
    const data = window.globalData;

    return (
        <BrowserRouter>
            <Route
                path={'/careers'}
                render={(props) => (
                    <PageLayout {...props} data={data}>
                        <ScrollToTop {...props.location} />
                    </PageLayout>
                )}
            />
        </BrowserRouter>
    );
}

export default hot(module)(Root);
